var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100" }, [
    !_vm.is_load
      ? _c(
          "div",
          { staticClass: "loader_calendar w-100 text-center pt-5 mt-5" },
          [
            _c("sync-loader", {
              attrs: { loading: true, color: "#7a59ad", size: "10px" },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "calendar_block d-flex flex-column h-100" }, [
          _c("div", { staticClass: "h-auto" }, [
            _c(
              "table",
              {
                staticClass:
                  "table table-bordered table-calendar m-0 w-100 h-100 border-0",
              },
              [
                _c(
                  "tr",
                  { staticClass: "text-center" },
                  _vm._l(_vm.days_name, function (day_name) {
                    return _c("th", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" + _vm._s(day_name) + "\n\t\t\t\t\t\t"
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._l(_vm.month_data, function (week) {
                  return _c(
                    "tr",
                    _vm._l(week, function (day) {
                      return _c(
                        "td",
                        {
                          class: {
                            "text-muted bg-faded": !day.is_enable,
                            "bg-primary-300 pattern-0": day.is_active,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.set_active_day(day)
                            },
                          },
                        },
                        [
                          _vm.has_birthday(day)
                            ? _c("i", {
                                staticClass:
                                  "fal fa-birthday-cake mt-1 ml-1 position-absolute pos-left pos-top text-primary",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "cursor-pointer" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(day.date_number) +
                                "\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 custom-scroll" }, [
            _c("div", { staticClass: "p-2" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center text-left mb-3" },
                [
                  _vm.active_day != undefined
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "width-5 fw-300 text-primary l-h-n mr-1 align-self-start fs-xxl",
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.active_day.date_number) +
                              "\n\t\t\t\t\t\t"
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-1" }, [
                    _vm.active_day != undefined
                      ? _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "span",
                            { staticClass: "l-h-n fs-md fw-500 opacity-70" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.active_day.month_name) +
                                  " " +
                                  _vm._s(_vm.active_day.year) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "l-h-n fs-nano fw-400 text-secondary",
                            },
                            [
                              _vm._v(
                                "\n                                     " +
                                  _vm._s(_vm.active_day.full_name) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.active_day != undefined
                ? _c(
                    "div",
                    { staticClass: "mt-3" },
                    _vm._l(_vm.active_day.birthdays, function (user) {
                      return _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center border-bottom pt-2 pb-2",
                          on: {
                            click: function ($event) {
                              return _vm.show_user(user)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "status mr-2" }, [
                            _c("span", {
                              staticClass:
                                "profile-image-md rounded-circle d-inline-block",
                              style: {
                                "background-image":
                                  "url(" + user.medium_img + ")",
                                "background-size": "cover",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "d-flex flex-column flex-1 ml-1" },
                            [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(user.name)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "msg-a fs-sm" }, [
                                _vm._v(
                                  _vm._s(user.company) +
                                    "\n                                        "
                                ),
                                _c("small", [_vm._v(_vm._s(user.dolznost))]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "fs-nano text-muted mt-1" },
                                [_vm._v(_vm._s(user.data_1c.birthday))]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }